<template>
	<div class="k-component -hero-video">
		<Logo ref="logo" />
		<div ref="player" id="hero-player" class="hero-player">
			<div ref="poster" id="hero-poster" class="hero-poster"></div>
			<video ref="video" @play="playing()" @pause="pausing()" playsinline muted loop id="hero-video">
				<source :src="videoMp4" type="video/mp4" />
				<source :src="videoWebm" type="video/webm" />
			</video>
		</div>
		<div ref="controls" id="hero-controls" class="hero-controls">
			<FAIcon icon="stop" fixed-width @click="stop" />
			<FAIcon icon="play" size="lg" fixed-width ref="playButton" @click="play" style="display:none;" />
			<FAIcon icon="pause" size="lg" fixed-width ref="pauseButton" @click="pause" />
			<FAIcon icon="volume-up" fixed-width ref="soundButton" @click="sound" />
			<FAIcon icon="volume-mute" fixed-width ref="muteButton" @click="mute" style="display:none;" />
		</div>
		<div ref="actions" id="hero-actions" class="hero-actions">
			<FAIcon icon="angle-down" size="lg" v-scroll-to="'#main'" />
		</div>
	</div>
</template>

<script>
import Logo from '@/components/Logo.vue'

export default {
	name: 'Hero',

	components: {
		Logo
	},

	props: {
		heroData: {
			type: Object,
			required: true
		}
	},

	data() {
		return {
			focusID: undefined
		}
	},

	computed: {
		isPlayerVisible() {
			let wHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0)
			let wOffsetY = window.pageYOffset

			return (wHeight * this.heroData.playeVisiblePoint) / 100 > wOffsetY
		},
		videoMp4() {
			return require('@/assets/media/' + this.heroData.videoName + '.mp4')
		},
		videoWebm() {
			return require('@/assets/media/' + this.heroData.videoName + '.webm')
		}
	},

	mounted() {
		this.start()
	},

	methods: {
		start() {
			setTimeout(() => {
				this.focusLogo().then(() => {
					this.animateLogo().then(() => {
						this.initiateVideo().then(video => {
							const message = this.isPlayerVisible ? '%cHero Video Playing!' : '%cHero Video Ready!'

							console.info(message, this.$store.state.consoleInfoStyle)
							this.$store.dispatch('hero/fetchVideo', video)
						})
					})
				})
			}, 400)
		},
		focusLogo() {
			return new Promise(resolve => {
				const loops = 1
				let loop = 0
				let isZero = false
				let deviation = 0
				let vueThis = this

				function step() {
					const newDeviation = Math.random() * (0.14 - 0.06) + 0.08
					const blurValue = 16 * (Math.sin((deviation += newDeviation)) + 1)
					const roundedBlur = Math.round(blurValue)

					if (loop <= loops) {
						if (roundedBlur === 0) {
							isZero = true
						} else if (roundedBlur === 1 && isZero === true) {
							isZero = false
							loop++
						}

						const blur = document.querySelector('#filterBlur feGaussianBlur')
						blur.setAttribute('stdDeviation', blurValue)

						vueThis.focusID = window.requestAnimationFrame(step)
					} else {
						resolve()
					}
				}

				this.focusID = window.requestAnimationFrame(step)
			})
		},
		animateLogo() {
			return new Promise(resolve => {
				const logo = this.$refs.logo.$el
				const logoStyle = window.getComputedStyle(logo)
				let bottom = parseInt(logoStyle.getPropertyValue('bottom'), 10)
				let width = parseInt(logoStyle.getPropertyValue('width'), 10)
				const targetWidth =
					(width - this.heroData.targetLogoWidth) / ((bottom - this.heroData.targetLogoBottom) / 2)

				const interval = setInterval(() => {
					if (bottom <= this.heroData.targetLogoBottom) {
						clearInterval(interval)
						resolve()
					} else {
						bottom = bottom - 2
						width = width - targetWidth
						logo.style.bottom = bottom + 'px'
						logo.style.width = width + 'px'
					}
				}, 4)
			})
		},
		initiateVideo() {
			return new Promise(resolve => {
				const controls = this.$refs.controls
				const actions = this.$refs.actions

				controls.style.display = 'block'
				actions.style.display = 'block'

				if (this.isPlayerVisible) {
					this.$refs.video.play()
				} else {
					this.$refs.playButton.style.display = 'inline-block'
					this.$refs.pauseButton.style.display = 'none'
				}

				resolve(this.$refs.video)
			})
		},

		playing() {
			this.$refs.poster.classList.add('-hidden')
			this.$refs.player.classList.remove('-paused')
			this.$refs.pauseButton.style.display = 'inline-block'
			this.$refs.playButton.style.display = 'none'
		},
		pausing() {
			if (this.$refs.video.currentTime !== 1) {
				this.$refs.player.classList.add('-paused')
			}

			this.$refs.playButton.style.display = 'inline-block'
			this.$refs.pauseButton.style.display = 'none'
		},

		play() {
			this.$refs.video.play()
		},
		pause() {
			this.$refs.video.pause()
		},
		stop() {
			const video = this.$refs.video
			video.currentTime = 1
			video.pause()
		},
		sound() {
			this.$refs.video.muted = false
			this.$refs.muteButton.style.display = 'inline-block'
			this.$refs.soundButton.style.display = 'none'
		},
		mute() {
			this.$refs.video.muted = true
			this.$refs.soundButton.style.display = 'inline-block'
			this.$refs.muteButton.style.display = 'none'
		}
	}
}
</script>

<style lang="scss">
@import '@/assets/scss/_component-hero.scss';
</style>
